




























































































import {
  Vue,
  Component,
  Prop,
  Watch,
} from "@/shared/vuepack";
import {
  TransactionEditSearch,
  TransactionEditSearchItem,
} from "@/shared/types";
import { Location } from "vue-router";
import { formatDateString } from "@/shared/dateString";
import { formatCurrency } from "@/shared/currency";
import { Validator } from "vee-validate";

import Edit from "./Edit.vue";
import { useTransactionEditStore } from "@/admin/store/transactionEdit";


interface TransEditQueryString extends TransactionEditSearch {
  transactionId?: string;
}

@Component({
  components: { Edit }
})
export default class TransactionEdit extends Vue {
  formatDateString = formatDateString;
  formatCurrency = formatCurrency;

  searchEmail = "";
  searchFirst = "";
  searchLast = "";
  searchAccount = "";
  searchPostDate: string = null;
  loadingSearchResults = false;
  $validator: Validator;

  transactionEditStore = useTransactionEditStore();

  @Prop() transactionId: string;
  @Prop() email: string;
  @Prop() postingDate: string;
  @Prop() first: string;
  @Prop() last: string;
  @Prop() account: string;

  @Prop() buildRoute: (query: TransEditQueryString) => Location;

  created (): void {
    this.loadComponent();
  }

  loadComponent (): void {
    this.searchEmail = this.email;
    this.searchPostDate = this.postingDate || null;
    this.searchFirst = this.first;
    this.searchLast = this.last;
    this.searchAccount = this.account;

    if (this.loadingSearchResults) {
      return;
    }

    if (this.validPropsForSearch) {

      this.loadingSearchResults = true;
      this.transactionEditStore.loadSearchResults({
            email: this.email,
            postDate: this.postingDate,
            firstName: this.first,
            lastName: this.last,
            account: this.account
          })
          .catch(_ => { /* noop */
          })
          .finally(() => this.loadingSearchResults = false);
    }
  }

  @Watch("email")
  @Watch("postingDate")
  @Watch("first")
  @Watch("last")
  @Watch("account")
  onPropertyChanged () {
    this.loadComponent();
  }

  get validPropsForSearch (): boolean {
    return !!this.postingDate && (!!this.account || !!this.email || (!!this.first && !!this.last));
  }

  get isLoading (): boolean {
    return this.transactionEditStore.getSearchResults === null;
  }

  get isEmpty (): boolean {
    return this.transactionEditStore.getSearchResults && this.transactionEditStore.getSearchResults.transactions.length === 0;
  }

  get gridData (): TransactionEditSearchItem[] {
    if (this.transactionEditStore.getSearchResults && this.transactionEditStore.getSearchResults.transactions) {
      return this.transactionEditStore.getSearchResults.transactions;
    }
    return null;
  }

  get accountFound (): boolean {
    return this.validPropsForSearch && !!this.firstName;
  }

  get showEdit () {
    return !!this.transaction;
  }

  get firstName (): string {
    return this.transactionEditStore.getSearchResults && this.transactionEditStore.getSearchResults.firstName;
  }

  get lastName (): string {
    return this.transactionEditStore.getSearchResults && this.transactionEditStore.getSearchResults.lastName;
  }

  get employerId (): number {
    return this.transactionEditStore.getSearchResults && this.transactionEditStore.getSearchResults.employerId;
  }

  get employerName (): string {
    return this.transactionEditStore.getSearchResults && this.transactionEditStore.getSearchResults.employerName;
  }

  get custodianName (): string {
    return this.transactionEditStore.getSearchResults && this.transactionEditStore.getSearchResults.custodianName;
  }

  get searchFormError () {
    return this.$validator.errors.any();
  }

  searchSubmit () {
    this.$validator.validateAll().then(isValid => {
      if (isValid) {
        this.navigateToSearch();
      }
    });
  }

  get fieldConfiguration () {
    return [
      { key: "editButton", label: "" },
      { key: "transactionType", label: "Transaction Type" },
      { key: "amount" },
      { key: "description" },
      { key: "effectiveYear", label: "Effective Year" },
      { key: "isArchived", label: "Archived" },
    ];
  }

  get transaction (): TransactionEditSearchItem {
    if (this.transactionEditStore.getSearchResults) {
      const transactionId = parseInt(this.transactionId, 10);
      const transactions = this.transactionEditStore.getSearchResults.transactions || [];
      const filtered = transactions.filter(t => t.id === transactionId);
      return filtered.length === 1 ? filtered[0] : null;
    }
    return null;
  }

  formatArchived (isArchived: boolean): string {
    return isArchived ? "Yes" : "No";
  }

  navigateToSearch () {
    const q: TransEditQueryString = {
      postDate: this.searchPostDate
    };
    q.email = this.searchEmail;
    q.firstName = this.searchFirst;
    q.lastName = this.searchLast;
    q.account = this.searchAccount;

    this.$router.push(this.buildRoute(q));
  }

  navigateToEdit (transactionId: string) {
    const q: TransEditQueryString = {
      postDate: this.postingDate,
      transactionId
    };
    q.email = this.email;
    q.firstName = this.first;
    q.lastName = this.last;
    q.account = this.account;
    this.$router.push(this.buildRoute(q));
  }

  editClick (item: TransactionEditSearchItem) {
    this.navigateToEdit(item.id.toString());
  }
}
